export const locale = {
  'CANCELCONFIRM' : {
    'TITLE' : 'Cancel order',
    'MESSAGE' : 'Are you sure you want to cancel this orders?',
    'CONFIRM' : 'Yes, cancel',
    'DECLINE' : 'Close',
    'ORDERNUMBER' : 'Order #',
  },
};
